import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useSendToSupportMutation } from '../../../services/api';
import Button from '../Button/Button';
import Form from '../Form';
import { Modal } from '../Modal';
import TextInput from '../TextInput';
import { GuestAttachModalProps } from './types';

export function GuestAttachModal({ isOpen, onClose }: GuestAttachModalProps) {
    const [sendMessage] = useSendToSupportMutation();
    const [success, setSuccess] = useState<boolean>();
    const [fail, setFail] = useState<string>();
    const [message, setMessage] = useState('');
    const successClass = 'popup_message';

    useEffect(() => {
        if (isOpen) {
            setSuccess(false);
            setFail('');
        }
    }, [isOpen]);

    return (
        <Modal className={success ? successClass : 'form-opinion'} isOpen={isOpen} onClose={() => onClose()}>
            {success ?
                <div className="form-message _success">
                    <div className="form-message__icon"></div>
                    <h2 className="popup__heading form-message__heading">
                        <Trans>dashboard:GUEST_ATTACH_SEND</Trans>
                    </h2>
                    <div className="form-message__ok">
                        <span className="btn" onClick={() => onClose()}><Trans>modal:SUCCESS_MESSAGE_CONFIRM</Trans></span>
                    </div>
                </div>
                :
                (fail
                    ?
                    <div className="form-message _error">
                        <div className="form-message__icon"></div>
                        <h2 className="popup__heading form-message__heading"><Trans>modal:ERROR_MESSAGE_TITLE</Trans></h2>
                        <div className="form-message__copy">
                            {fail}
                        </div>
                        <div className="form-message__ok">
                            <span className="btn" onClick={() => onClose()}><Trans>modal:ERROR_MESSAGE_CONFIRM</Trans></span>
                        </div>
                    </div>
                    :
                    <Form action="#" className="form-opinion" id="provide-opinion">
                        <h1 className="form-opinion__heading"><Trans>dashboard:GUEST_ATTACH_TITLE</Trans></h1>
                        <p><Trans>dashboard:GUEST_ATTACH_BODY</Trans></p>
                        <div className="form__item">
                            <TextInput
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                                placeholder={t('account:NAME')}
                            />
                        </div>
                        <div className="form__submit">
                            <Button
                                disabled={message.length === 0}
                                onClick={() => {
                                    sendMessage(`${t('dashboard:I_WANT')} ${message}`).unwrap().then(() => {
                                        setSuccess(true);
                                    }).catch(e => {
                                        setFail(JSON.stringify(e));
                                    })
                                }}
                            >
                                <Trans>Send</Trans>
                            </Button>
                        </div>
                    </Form>
                )
            }
        </Modal>
    );
}